import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Grid3X3, ScanLine, ShoppingCart, User } from "lucide-react";
import { useCart } from "../lib/cart";

const items = [
    { to: "/", icon: Home, label: "Home", end: true },
    { to: "/category/all", icon: Grid3X3, label: "Shop" },
    { to: "/account/scan", icon: ScanLine, label: "Scan", fab: true },
    { to: "/cart", icon: ShoppingCart, label: "Cart", showCount: true },
    { to: "/account", icon: User, label: "Account" },
];

export default function MobileBottomNav() {
    const loc = useLocation();
    const { count } = useCart();
    if (/^\/(checkout|login|admin)/.test(loc.pathname)) return null;
    return (
        <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-t border-[rgba(11,20,55,0.10)] pb-[env(safe-area-inset-bottom)] shadow-[0_-8px_24px_-12px_rgba(11,20,55,0.10)]">
            <div className="max-w-2xl mx-auto px-2 pt-1.5 pb-1.5 flex items-center justify-between">
                {items.map(({ to, icon: Icon, label, end, fab, showCount }) => {
                    const active = end ? loc.pathname === to : loc.pathname.startsWith(to);
                    if (fab) {
                        return (
                            <NavLink key={to} to={to} className="flex flex-col items-center -mt-6">
                                <div className="w-[52px] h-[52px] rounded-full bg-[#0b1437] text-white flex items-center justify-center shadow-[0_8px_20px_-4px_rgba(11,20,55,0.40)] ring-4 ring-white">
                                    <Icon size={24} />
                                </div>
                                <span className="text-[10px] text-[#6b7280] uppercase tracking-widest mt-0.5">{label}</span>
                            </NavLink>
                        );
                    }
                    return (
                        <NavLink key={to} to={to} end={end} data-testid={`mnav-${label.toLowerCase()}`} className={`relative flex flex-col items-center gap-0.5 p-2 ${active ? "text-[#0b1437]" : "text-[#9ca3af]"}`}>
                            <Icon size={20} />
                            <span className={`text-[10px] uppercase tracking-widest ${active ? "font-semibold" : ""}`}>{label}</span>
                            {showCount && count > 0 && (
                                <span className="absolute top-1 right-1.5 min-w-[16px] h-[16px] rounded-full bg-[#e11d48] text-white text-[9px] font-bold flex items-center justify-center px-1">
                                    {count}
                                </span>
                            )}
                            {active && <span className="absolute -bottom-0.5 w-6 h-0.5 rounded-full bg-[#c9a959]" />}
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
}
